<ng-container *ngIf="label$ | async as label">
  <span class="text-xs">
    {{ label.title }}
  </span>
  <ng-container *ngIf="showSubtitle$ | async">
    <span *ngIf="label.subtitle" class="mat-caption">
      ({{ label.subtitle }})
    </span>
  </ng-container>
</ng-container>
